import { Navigate, useSearchParams } from 'react-router-dom';

/** /agency was one page with Team and Copy tabs; each has its own route now (ADR 0031).
 *  Old links keep working. */
export function AgencyPage() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  if (tab === 'copy') return <Navigate to="/copy" replace />;
  if (tab === 'statistics') return <Navigate to="/statistics" replace />;
  const team = searchParams.get('team');
  return <Navigate to={team ? `/team?team=${encodeURIComponent(team)}` : '/team'} replace />;
}
